import PageTitle from "@/components/Form/PageTitle/PageTitle";
import CustomTabPanel from "./CustomTabPanel";
import ClaimItems from "./ClaimItems/ClaimItems";
import UploadDocument from "./UploadDocument/UploadDocument";
import { MotifIcon } from "@ey-xd/motif-react";
import ReviewAndSubmit from "./ReviewAndSubmit/ReviewAndSubmit";
import { useEffect, useState } from "react";
import Description from "./Description/Description";
import Debtor from "./Debtor/Debtor";
import Creditor from "./Creditor/Creditor";
import SelectAssignee from "./SelectAssignee/SelectAssignee";
import Attributes from "./Attributes/Attributes";
import "./ClaimSetup.scss";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";
import { useLocation, useParams } from "react-router-dom";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import useResetAllClaimItemsStore from "./useResetAllClaimItemsStore";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useCase } from "@/features/case/use-case";
import { ActiveTabsOrder } from "@/menuData";

export default function ClaimSetup() {
  const location = useLocation();
  const {t}=useTranslation()
  const { caseId } = useParams();
  const {caseName} = useCase(caseId);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [showReviewAndSubmit, setShowReviewAndSubmit] = useState(false);
  const [isDiscardVisible, setIsDiscardVisible] = useState(false);
  const [stageDoc, setStageDoc] = useState<any>();
  const [files, setFiles] = useState<File[]>([]);
  const CreditorIDFromCreditorClaim = location.state;
  const DebtorID = CreditorIDFromCreditorClaim?.debtorId;
  const { search } = useLocation();
  const CreditorID = new URLSearchParams(search).get("creditorId") || undefined;
  const debtorId = new URLSearchParams(search).get("debtorId") || undefined;
  const debtorName = new URLSearchParams(search).get("debtorName") || undefined;
   const creditorName = new URLSearchParams(search).get("creditorName") || undefined;


  const [fieldRequirements, setFieldRequirements] = useState({
    isAssigneeDescriptionRequired: false,
    isCreditorDescriptionRequired: false,
  });
  const resetAllClaimItemsStore = useResetAllClaimItemsStore();
  const dispatch = useDispatch()

  useEffect(() => {
    if (location.state?.activeTabIndex !== undefined) {
      setActiveTabIndex(location.state.activeTabIndex);
      setShowReviewAndSubmit(false);
    }
  }, [location]);

  const [formSubmissionStatus, setFormSubmissionStatus] = useState({
    details: false,
    debtor: false,
    creditor: false,
    assignee: false,
    claimItems: false,
    claimAttribute: false,
    uploadDocument: false,
  });

  const updateFormSubmissionStatus = (formName: any, status: any) => {
    setFormSubmissionStatus((prevStatus) => ({
      ...prevStatus,
      [formName]: status,
    }));
  };
  const showReviewPage = () => {
    setShowReviewAndSubmit(true);
  };



  const handleCancelDiscard = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsDiscardVisible(false);
    dispatch(setDiscardEditMode({ editMode: true }))
  };

  const handleConfirmDiscard = (event: any) => {
    event.preventDefault();
        // navigate(`/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`);
    resetAllClaimItemsStore();
    setIsDiscardVisible(false);
  };

  const goToNextTab = () => {
    if (activeTabIndex < tabs.length - 1) {
      setActiveTabIndex((prevIndex) => prevIndex + 1);
      const currentFormName = tabs[activeTabIndex].name;
      updateFormSubmissionStatus(currentFormName, true);
    } else {
      setShowReviewAndSubmit(true);
    }
  };

  const handleReviewAndSubmitResponse = (response: any) => {
    const additionalMessageObject = response.additionalMessageObject;

    setFieldRequirements({
      isAssigneeDescriptionRequired:
        additionalMessageObject?.isAssignee === "True" &&
        additionalMessageObject?.description === "Required",
      isCreditorDescriptionRequired:
        additionalMessageObject?.description === "Required",
    });
  }

  const tabs = [
    {
      name: "Details",
      label: t("pages.claims.claimCreate.sideTabPanelDetails.details"),
      component: (
        <Description
          goToNextTab={goToNextTab}
          file={stageDoc}
          setFile={setStageDoc}
        />
      ),
    },
    {
      name: "debtor",
      label: t("pages.claims.claimCreate.sideTabPanelDetails.debtor"),
      component: <Debtor goToNextTab={goToNextTab} DebtorID={DebtorID} />,
    },
    {
      name: "creditor",
      label: t("pages.claims.claimCreate.sideTabPanelDetails.creditor"),
      component: (
        <Creditor
          goToNextTab={goToNextTab}
          CreditorCaseID={caseId}
          CreditorID={CreditorID}
          isDescriptionRequired={fieldRequirements.isCreditorDescriptionRequired}
        />
      ),
    },
    {
      name: "select-an-assignee",
      label: t("pages.claims.claimCreate.sideTabPanelDetails.assignee"),
      component: <SelectAssignee
        goToNextTab={goToNextTab}
        isDescriptionRequired={fieldRequirements.isAssigneeDescriptionRequired}
      />,
    },
    {
      name: "claim-items",
      label: t("pages.claims.claimCreate.sideTabPanelDetails.claimIteams"),
      component: <ClaimItems goToNextTab={goToNextTab} />,
    },
    {
      name: "claim-attribute",
      label: t("pages.claims.claimCreate.sideTabPanelDetails.claimAttribute"),
      component: <Attributes goToNextTab={goToNextTab} />,
    },
    {
      name: "upload-document",
      label: t("pages.claims.claimCreate.sideTabPanelDetails.uploadDocumnet"),
      component: (
        <UploadDocument
          showSetReviewPage={showReviewPage}
          files={files}
          setFiles={setFiles}
        />
      ),
    },
  ];

  const handleTabChange = (index: number) => {
    setActiveTabIndex(index);
  };

  const breadcrumbItem =debtorId && debtorName?[
    {
      text: caseName || t("global.globalActions.backTo",{pageName:"Case"}),
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.DEBTOR}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      text: debtorName?.replace(/_/g," ") || t("global.globalActions.backTo",{pageName:"Debtor"}),
      url: `/case/${caseId}/debtor/edit/${debtorId}/?activeTab=1`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
  },
    {
      text: t("pages.claims.claimsTable.createClaim"),
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled:true
    },
  ]:CreditorID && creditorName?[
    {
      text: caseName || t("global.globalActions.backTo",{pageName:"Case"}),
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CREDITOR}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      text: creditorName?.replace(/_/g," ") || t("global.globalActions.backTo",{pageName:"Creditor"}),
      url: `/case/${caseId}/creditor/${CreditorID}?activeTab=1`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      text: t("pages.claims.claimsTable.createClaim"),
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled:true
    },
  ]: [
    {
      text: caseName || t("global.globalActions.backTo",{pageName:"Case"}),
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
    },
    {
      text: t("pages.claims.claimsTable.createClaim"),
      url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`,
      icon: <MotifIcon src={IconoirArrowLeft} />,
      disabled:true
    },
  ];
useEffect(()=>{
  return ()=>{
    resetAllClaimItemsStore();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[])
  return (
    <>
      {!showReviewAndSubmit && (
        <div
          style={{ cursor: "pointer" }}
        >
          <Breadcrumb items={breadcrumbItem} />{" "}
        </div>
      )}
      <div className="display-flex align-items-lg-start">
        {showReviewAndSubmit && (
          <Breadcrumb items={[ {
            text: caseName || t("global.globalActions.backTo",{pageName:"Case"}),
            url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`,
            icon: <MotifIcon src={IconoirArrowLeft} />,
          },{
            text: t("pages.claims.claimCreate.newClaim"),
            url: `/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`,
            icon: <MotifIcon src={IconoirArrowLeft} />,
            disabled:true
          }]} />
        )}
      </div>
      <PageTitle title={"pages.claims.claimCreate.title"} description={"pages.claims.claimCreate.description"} />
      {!showReviewAndSubmit && (
        <CustomTabPanel
          tabs={tabs}
          activeTabIndex={activeTabIndex}
          onTabChange={handleTabChange}
          formSubmissionStatus={formSubmissionStatus}
        />
      )}
      {showReviewAndSubmit && (
        <ReviewAndSubmit stageDoc={stageDoc} files={files} onResponse={handleReviewAndSubmitResponse} />
      )}

      <ConfirmationModal
        isVisible={isDiscardVisible}
        setIsVisible={setIsDiscardVisible}
        cancelBtnApproveHandler={handleConfirmDiscard}
        cancelBtnRejectHandler={handleCancelDiscard}
      />
    </>
  );
}

